import React, { useEffect } from "react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { selectPosFlow } from "../store/posSlice";

// screens
import { PaymentMethodScreen } from "../pages/PaymentMethodPage";
import { CashPaymentScreen } from "../pages/CashPaymentPage";
import { GiftCardPaymentScreen } from "../pages/GiftCardPaymentPage";
import { PrintingScreen } from "../pages/PrintReceipt";
import { DoneScreen } from "../pages/PaymentSuccess";

export default function PosFlowPage() {
  const navigate = useNavigate();
  const { screen } = useAppSelector(selectPosFlow);

  // Optional: keep URL in sync with redux screen state
  useEffect(() => {
    const screenToPath: Record<string, string> = {
      payment_method: "/pos/payment-method",
      cash: "/pos/cash",
      card: "/pos/card",
      "gift-card": "/pos/gift-card",
      "card-on-file": "/pos/card-on-file",
      "manual-entry": "/pos/manual-entry",
      printing: "/pos/printing",
      done: "/pos/done",
    };
    const target = screenToPath[screen] ?? "/pos/payment-method";

    // only replace when needed (prevents loops)
    navigate(target, { replace: true });
  }, [screen, navigate]);

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/pos/payment-method" replace />} />
      <Route path="/payment-method" element={<PaymentMethodScreen />} />
      <Route path="/cash" element={<CashPaymentScreen />} />
      {/* Card methods are disabled until a real card processor is connected. */}
      <Route path="/card" element={<Navigate to="/pos/payment-method" replace />} />
      <Route path="/gift-card" element={<GiftCardPaymentScreen />} />
      <Route path="/card-on-file" element={<Navigate to="/pos/payment-method" replace />} />
      <Route path="/manual-entry" element={<Navigate to="/pos/payment-method" replace />} />
      <Route path="/printing" element={<PrintingScreen />} />
      <Route path="/done" element={<DoneScreen />} />
    </Routes>
  );
}